// extracted by css-extract-rspack-plugin
var _1 = "UsK89";
var _2 = "xzulX";
var _3 = "yEOVh";
var _4 = "ca3U7";
export { _1 as "backgroundGradient", _2 as "backgroundImage", _3 as "copilotBackgroundGradient", _4 as "copilotDarkBackground" }
